import React, { memo } from 'react'
import moment from 'moment'
import { MapMarker, TStopType } from 'transfix-ui/components/MapMarker'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { Stop } from 'apps/fleet-planner/types'
import { formatCityState } from 'utils/formatCityState'
import { AllowedTimezones } from 'constants/AllowedTimezones'
import FORMATS from 'constants/datetime'
import { useTextStyles } from '../DriverValidationPage'

interface IStopSummaryItemProps {
  stop: Stop
  isLastStop: boolean
}

export const StopSummaryItem = memo<IStopSummaryItemProps>(({ isLastStop, stop }) => {
  const { address, displayTimezone, startAt = '', stopType } = stop || {}
  const timezone = displayTimezone as AllowedTimezones
  const { locality, subdivisionCode } = address || {}

  const cityState = formatCityState(`${locality}`, `${subdivisionCode}`)

  const datetime = moment
    .tz(startAt, timezone)
    .format(FORMATS.dayMonthTimeShortOnlyHoursWithTimezone)

  const classes = useTextStyles()

  return (
    <Box display='flex' alignItems='center' marginBottom={isLastStop ? 0 : '16px'}>
      <Box marginRight='15px'>
        <MapMarker type={stopType as TStopType} mini />
      </Box>
      <Box>
        <Typography variant='body2' className={classes.bodyLinkTwo}>
          {cityState}
        </Typography>
        <Typography variant='body2' className={classes.bodyTwo}>
          {datetime}
        </Typography>
      </Box>
    </Box>
  )
})
